(function () {
  function initHarvestUse(root) {
    if (!root || root.dataset.harvestUseInitialized === 'true') {
      return;
    }

    root.dataset.harvestUseInitialized = 'true';

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-harvest-card]'));
    var filterButtons = Array.prototype.slice.call(root.querySelectorAll('[data-harvest-filter]'));
    var groupFilterRadios = Array.prototype.slice.call(root.querySelectorAll('[data-harvest-group-filter-radio]'));
    var useFilterChecks = Array.prototype.slice.call(root.querySelectorAll('[data-harvest-use-filter-check]'));
    var useFilterToggle = root.querySelector('[data-harvest-use-filter-toggle]');
    var useFilterReset = root.querySelector('[data-harvest-use-filter-reset]');
    var useFilterCloseButtons = Array.prototype.slice.call(root.querySelectorAll('[data-harvest-use-filter-close]'));
    var searchInput = root.querySelector('[data-harvest-search]');
    var countNode = root.querySelector('[data-harvest-count]');
    var noResults = root.querySelector('[data-harvest-no-results]');
    var activeFilter = root.getAttribute('data-initial-filter') || 'all';
    var mobileUseFilterQuery = window.matchMedia('(max-width: 720px)');

    function isMobileUseFilter() {
      return mobileUseFilterQuery.matches;
    }

    function updateUseFilterToggleState() {
      if (!useFilterToggle) {
        return;
      }

      var isExpanded = isMobileUseFilter()
        ? root.classList.contains('is-use-filter-open')
        : !root.classList.contains('is-use-filter-collapsed');

      useFilterToggle.classList.toggle('is-active', isExpanded);
      useFilterToggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
    }

    function setActiveFilter(nextFilter) {
      activeFilter = nextFilter || 'all';

      filterButtons.forEach(function (button) {
        var isActive = button.getAttribute('data-harvest-filter') === activeFilter;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      groupFilterRadios.forEach(function (radio) {
        radio.checked = radio.value === activeFilter;
      });
    }

    function applyFilters() {
      var query = searchInput ? searchInput.value.toLowerCase().trim() : '';
      var activeUses = useFilterChecks
        .filter(function (checkbox) {
          return checkbox.checked;
        })
        .map(function (checkbox) {
          return checkbox.value;
        });
      var visibleCount = 0;

      cards.forEach(function (card) {
        var cardGroup = card.getAttribute('data-harvest-group') || '';
        var cardText = card.getAttribute('data-harvest-search') || '';
        var cardUses = (card.getAttribute('data-harvest-uses') || '').split(/\s+/);
        var matchesGroup = activeFilter === 'all' || cardGroup === activeFilter;
        var matchesSearch = !query || cardText.indexOf(query) !== -1;
        var matchesUses = !activeUses.length || activeUses.every(function (useSlug) {
          return cardUses.indexOf(useSlug) !== -1;
        });
        var isVisible = matchesGroup && matchesSearch && matchesUses;

        card.hidden = !isVisible;

        if (isVisible) {
          visibleCount += 1;
        }
      });

      if (countNode) {
        countNode.textContent = visibleCount;
      }

      if (noResults) {
        noResults.hidden = visibleCount > 0;
      }

      if (useFilterReset) {
        useFilterReset.hidden = activeUses.length === 0 && activeFilter === 'all';
      }
    }

    function closeUseFilterDrawer() {
      root.classList.remove('is-use-filter-open');
      updateUseFilterToggleState();
    }

    function openUseFilterDrawer() {
      root.classList.add('is-use-filter-open');
      updateUseFilterToggleState();
    }

    function toggleUseFilterPanel() {
      if (isMobileUseFilter()) {
        openUseFilterDrawer();
        return;
      }

      root.classList.toggle('is-use-filter-collapsed');
      updateUseFilterToggleState();
    }

    filterButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var nextFilter = button.getAttribute('data-harvest-filter');

        if (button.classList.contains('is-active') && nextFilter !== 'all') {
          nextFilter = 'all';
        }

        setActiveFilter(nextFilter);
        applyFilters();
      });
    });

    groupFilterRadios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (radio.checked) {
          setActiveFilter(radio.value);
          applyFilters();
        }
      });
    });

    useFilterChecks.forEach(function (checkbox) {
      checkbox.addEventListener('change', applyFilters);
    });

    if (useFilterReset) {
      useFilterReset.addEventListener('click', function () {
        useFilterChecks.forEach(function (checkbox) {
          checkbox.checked = false;
        });

        setActiveFilter('all');
        applyFilters();
      });
    }

    if (useFilterToggle) {
      useFilterToggle.addEventListener('click', toggleUseFilterPanel);
    }

    if (mobileUseFilterQuery.addEventListener) {
      mobileUseFilterQuery.addEventListener('change', updateUseFilterToggleState);
    } else if (mobileUseFilterQuery.addListener) {
      mobileUseFilterQuery.addListener(updateUseFilterToggleState);
    }

    useFilterCloseButtons.forEach(function (button) {
      button.addEventListener('click', closeUseFilterDrawer);
    });

    root.addEventListener('keyup', function (event) {
      if (event.key === 'Escape') {
        closeUseFilterDrawer();
      }
    });

    if (searchInput) {
      searchInput.addEventListener('input', applyFilters);

      var form = searchInput.closest('form');

      if (form) {
        form.addEventListener('submit', function (event) {
          event.preventDefault();
          applyFilters();
        });
      }
    }

    setActiveFilter(activeFilter);
    updateUseFilterToggleState();
    applyFilters();
  }

  function initAllHarvestUseSections() {
    Array.prototype.slice.call(document.querySelectorAll('[data-harvest-use]')).forEach(initHarvestUse);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllHarvestUseSections);
  } else {
    initAllHarvestUseSections();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initHarvestUse(event.target.querySelector('[data-harvest-use]'));
  });
})();
